/**
 * @fileoverview DELETE handler for the "/apps/multi_language_settings/remove_translations" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsRemoveTranslationsCacheKeys } from "./constants";
import type {
  DeleteAppsMultiLanguageSettingsRemoveTranslationsProps,
  AppsMultiLanguageSettingsRemoveTranslationsResult,
} from "./types";

export const deleteAppsMultiLanguageSettingsRemoveTranslations = reactQueryMutationAdapter(
  appsMultiLanguageSettingsRemoveTranslationsCacheKeys,
  (
    props: DeleteAppsMultiLanguageSettingsRemoveTranslationsProps
  ): Promise<AppsMultiLanguageSettingsRemoveTranslationsResult> => {
    return fetch(
      "/apps/multi_language_settings/remove_translations",
      "DELETE",
      {
        translation_ids: props.translationIds,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
